import Vue from "vue";
import Router from "vue-router";

import Home from "./components/Home.vue";
import Quiz from "./components/Quiz.vue";
import Answer from "./components/Answer.vue";
import Result from "./components/Result.vue";
import Certificate from "./components/Certificate.vue";

Vue.use(Router);

export default new Router({
  mode: "abstract",
  routes: [
    {
      path: "/",
      component: Home
    },
    {
      path: "/quiz",
      component: Quiz
    },
    {
      path: "/answer/:correctness/:quizId",
      component: Answer,
      props: true,
    },
    {
      path: "/result",
      component: Result
    },
    {
      path: "/certificate",
      component: Certificate
    },
    // {
    //   path: "/detail/:id",
    //   component: DetailId
    // },
    // {
    //   path: "/nest",
    //   component: Nest,
    //   children: [
    //     {
    //       path: "",
    //       component: Child1
    //     },
    //     {
    //       path: "child2",
    //       component: Child2
    //     },
    //     {
    //       path: "child3",
    //       component: Child3
    //     }
    //   ]
    // }
  ]
});
